"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TemplateInitializerDefinition = void 0;
const WidgetInitializerPlugin_1 = require("auto-widget-framework/src/Plugin/WidgetInitializer/WidgetInitializerPlugin");
const WidgetInitializerPluginDefinition_1 = require("auto-widget-framework/src/Plugin/WidgetInitializer/WidgetInitializerPluginDefinition");
const IContainerInjection_1 = require("auto-widget-framework/src/Container/IContainerInjection");
const Mixin_1 = require("auto-widget-framework/src/Util/Mixin");
const RepositoryTypes_1 = require("../../Enum/RepositoryTypes");
/**
 * Initializes template and css for the widget.
 */
class TemplateInitializer extends WidgetInitializerPlugin_1.default {
    /**
     * Creates template initializer.
     *
     * @param definition
     * @param repositoryFactory
     * @param assetManager
     * @param loadTemplates
     */
    constructor(definition, repositoryFactory, assetManager, loadTemplates) {
        super(definition);
        this.repositoryFactory = repositoryFactory;
        this.assetManager = assetManager;
        this.loadTemplates = loadTemplates;
    }
    /**
     * @inheritDoc
     */
    static create(definition, container) {
        return new this(definition, container.get('factory.repository'), container.get('asset_manager'), container.getParameter('load_templates'));
    }
    /**
     * @inheritDoc
     */
    initialize(config, state) {
        let repository = this.repositoryFactory.create(RepositoryTypes_1.RepositoryTypes.TEMPLATE, { config });
        let promises = [];
        this.loadTemplates.forEach((id) => {
            if (id) {
                promises.push(repository.get(id));
            }
            else {
                promises.push(Promise.resolve(null));
            }
        });
        return Promise.all(promises)
            .then((values) => {
            let cssPromises = [];
            values.forEach((template) => {
                if (!template) {
                    return;
                }
                config.setTemplate(template.getId(), template);
                template.getCss().forEach((css) => {
                    cssPromises.push(this.assetManager.addStyle(css));
                });
            });
            return Promise.all(cssPromises)
                .then((cssValue) => cssValue);
        });
    }
}
exports.default = TemplateInitializer;
exports.TemplateInitializerDefinition = new WidgetInitializerPluginDefinition_1.default({
    id: "template_initializer",
    class: TemplateInitializer,
    priority: 100,
});
Mixin_1.default(TemplateInitializer, IContainerInjection_1.default);
